import { render, staticRenderFns } from "./CommunicationAllActivities.vue?vue&type=template&id=29c4d77c"
import script from "./CommunicationAllActivities.vue?vue&type=script&lang=ts"
export * from "./CommunicationAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports